import React, { Component } from 'react'
import { Layout } from '../../widgets'
import * as routes from '../../routes'
import PaginatedList from './PaginatedList'
import { NavigationTab, AdminBeatCell } from '../components'

const tabs = ['Hot', 'Featured', 'New']

class AdminBeatFeeds extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: tabs[0]
    }
  }

  render = () => {
    var loadParams = null;
    var key = null;

    switch (this.state.tab) {
      case 'Hot':
        loadParams = {'type': 'all_scored'}
        key = 'all_scored'
        break;
      case 'Featured':
        loadParams = {'type': 'featured_new'};
        key = 'featured_new'
        break;
      case 'New':
        key = 'all_new'
        loadParams = {'type': 'all_new'}
        break;
      default:
        throw new Error('Unimplemented tab: ' + this.state.tab)
    }

    return (
      <div className='body-container'>
        <Layout>
          <Layout.Header>Beat Feeds</Layout.Header>
          <div className='moderator-content'>

            <div className='navigation-tabs'>
              {tabs.map((tab, i) => (
                <NavigationTab
                  key={i}
                  text={tab}
                  isActive={this.state.tab === tab}
                  onClick={() => {
                    if (this.state.tab !== tab) {
                      this.setState({ tab: tab })
                    }
                  }}
                />
              ))}
            </div>

            <div className="admin-feed">
              <PaginatedList
                key={key}
                loadUrl={routes.adminBeatFeedUrl}
                loadParams={loadParams}
                adminCell={AdminBeatCell}
                adminCellItemPropName={'beat'}
              />
            </div>
          </div>
        </Layout>
      </div>
    )
  }
}

export default AdminBeatFeeds
